import { useRef, useState } from 'react'
import useIntersectionObserver from 'hooks/useIntersectionObserver';
import classnames from 'utils/classnames';

import { BsImage } from 'react-icons/bs';

const Image = ({ src, className, wrapperClassname, placeholder = <BsImage />, alt = "", ...rest }) => {
    const [error, setError] = useState(false);
    const [isInView, setIsInView] = useState(false);

    const imgRef = useRef(null);

    useIntersectionObserver(imgRef, () => setIsInView(true));

    const imgClassnames = classnames('w-full h-full relative z-10', className);
    const wrapperClassnames = classnames('w-full h-full bg-slate-200 relative', wrapperClassname);

    return (
        <div ref={imgRef} className={wrapperClassnames}>
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-6xl z-0 text-slate-500/50">
                {
                    placeholder
                }
            </div>
            {
                (isInView && !error && src) && (
                    <img src={src} alt={alt} className={imgClassnames} onError={() => setError(true)} {...rest} />
                )
            }
        </div>
    )
}

export default Image